import http from './http'

export const apiGetCountDown = () => http.post('/web/eidaladha/count/down')
export const apiGetUserRank = () => http.post('/web/eidaladha/user/rank')
export const apiGetGroupRank = () => http.post('/web/eidaladha/group/rank')
export const apiGetUserScore = () => http.post('/web/eidaladha/user/score')
export const apiExtractReward = (id) => http.post('/web/eidaladha/extract/reward',{id})


// WEBPACK FOOTER //
// src/helper/eidaladha.js